import { render } from "./DocumentViewer.vue?vue&type=template&id=4611cb4e&scoped=true"
import script from "./DocumentViewer.vue?vue&type=script&lang=js"
export * from "./DocumentViewer.vue?vue&type=script&lang=js"

import "./DocumentViewer.vue?vue&type=style&index=0&id=4611cb4e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4611cb4e"]])

export default __exports__